module.exports = __webpack_public_path__ + "img/turbo_off.49ad1477.svg";